import React from "react";

function Terms() {
  React.useEffect(() => {
    document.title = "Terms of User";
  }, []);

  return (
    <div
      style={{
        fontFamily: '"Helvetica Neue" ,Helvetica, Arial, "sans-serif"',
        padding: "2em",
      }}
    >
      <strong>Terms of User</strong> <p>SHAWER</p>
      <p>
        Subscriptions and in-app purchases: We offer several options for in-app
        purchases and subscriptions, including weekly,monthly,and yearly
        subscription. The user must have a valid ID account for financial
        procedures to be able to obtain the purchase service.
      </p>{" "}
      <p>
        Auto Renew: Subscriptions are currently renewing. The amount required
        for renewal is automatically collected by receiving it.
      </p>{" "}
      <p>
        Prices: Prices for products and in-app purchases vary according to the
        required options and features. Information about pricing can be found
        within the app before purchasing.
      </p>{" "}
      <p>
        Refund: Refund your money after returning a refund request to the Apple
        Store.
      </p>{" "}
      <p>
        Cancellation: Registration is canceled at any time. Alert: Submission of
        information in the former army. So, you should See the current current
        circle obtained information about registrations and in-app purchases via
        the Apple Store. Usage policy
      </p>{" "}
      <p>
        Note: The above information is provided for guidance only, and this
        policy may be subject to change and update at any time. So, you should
        See the current policy when you wish to receive information about
        subscriptions and in-app purchases Apple Store Road.
      </p>{" "}
      <p>
        <strong>Contact Us</strong>
      </p>{" "}
      <p>
        If you have any questions or suggestions about my Terms of User, do not
        hesitate to contact me at ahmadtech199@gmail.com.
      </p>{" "}
    </div>
  );
}

export default Terms;
